import React, { Component } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'

const getSMSCode = props => {
    const translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    let { currentData, propsCurrentData, sendPhoneNumber } = props
    let { value } = currentData
    let valueNum = value.replace(/[^A-Z|0-9]/gi, '')

    if (isValidPhoneNumber(value)) {
        if (valueNum !== propsCurrentData['value']) {
            return (
                <button
                    className="phone-number__button phone-number__button_get-code"
                    onClick={sendPhoneNumber}
                >
                    {translation['Get SMS with code']}
                </button>
            )
        }
    }
}

export default getSMSCode
